<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>📲 Push Notification config - Loads</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <h5>First Load Completed</h5>
      <mat-form-field>
        <mat-select placeholder="First Load Completed Template" formControlName="firstBtlCompletedTemplateId">
          <mat-option [value]="null">(none)</mat-option>
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Load issues</h5>

      <mat-form-field>
        <mat-select placeholder="Pending Load Template" formControlName="btlPendingLoadTemplateId">
          <mat-option [value]="null">(none)</mat-option>
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL Confirm Address template" formControlName="btlConfirmAddressTemplateId">
          <mat-option [value]="null">(none)</mat-option>
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL load below minimum template" formControlName="btlPendingBelowMinLoadTemplateId">
          <mat-option [value]="null">(none)</mat-option>
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL Declined load template" formControlName="btlDeclinedLoadTemplateId">
          <mat-option [value]="null">(none)</mat-option>
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Load success / partial success</h5>

      <mat-form-field>
        <mat-select placeholder="BTL successful load template" formControlName="btlSuccessLoadTemplateId">
          <mat-option [value]="null">(none)</mat-option>
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL successful partial load template" formControlName="btlSuccessPartialLoadTemplateId">
          <mat-option [value]="null">(none)</mat-option>
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>



    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
